import { useState, useCallback } from 'react';
import { Evaluator } from '@/types/evaluator';
import { create } from 'zustand';

interface EmailModalState {
  isOpen: boolean;
  evaluator: Evaluator | null;
  userEmail: string;
  openModal: (evaluator: Evaluator, userEmail: string) => void;
  closeModal: () => void;
}

export const useEmailModalStore = create<EmailModalState>((set) => ({
  isOpen: false,
  evaluator: null,
  userEmail: '',
  openModal: (evaluator, userEmail) => set({ isOpen: true, evaluator, userEmail }),
  closeModal: () => set({ isOpen: false, evaluator: null, userEmail: '' })
}));

export function useEmailCopyModal() {
  const { openModal, closeModal } = useEmailModalStore();

  const openEmailModal = useCallback((evaluator: Evaluator, userEmail: string) => {
    openModal(evaluator, userEmail);
  }, [openModal]);

  return {
    openEmailModal,
    closeModal
  };
}